import { combineReducers } from 'redux';

import rootReducer from './reducers/reducers';


const allReducers = combineReducers({
   counter: rootReducer,
});

export default allReducers;
